import { Component, OnInit, ViewChild } from '@angular/core';
import { MatHorizontalStepper, MatStep } from '@angular/material';
import { Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { ClientModel } from 'src/app/shared/models/client.model';
import { RmaRequestModel } from 'src/app/shared/models/rma.model';
import { RmaMasterService } from 'src/app/shared/services/rma-master.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-rma-request',
  templateUrl: './rma-request.component.html',
  styleUrls: ['./rma-request.component.css']
})
export class RmaRequestComponent implements OnInit {
  @ViewChild('stepper', {static: false}) stepper : MatHorizontalStepper;
  @ViewChild('customerstep', {static: false}) customerstep : MatStep;
  @ViewChild('productstep', {static: false}) productstep : MatStep;
  @ViewChild('shippingstep', {static: false}) shippingstep : MatStep;
  @ViewChild('finishstep', {static: false}) finishstep : MatStep;
  rmarequest : RmaRequestModel;

  constructor(
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private service : RmaMasterService,
    private router : Router)
  {
    this.rmarequest = new RmaRequestModel();
  }

  ngOnInit() {
    this.rmarequest.step = 1;
  }

  public onStepChange(event: any): void {
    console.log(event.selectedIndex);

    //if(this.call == null) return;
    //this.call.isLastStep = (event.selectedIndex == 2);

  }

  afterNextStep(data : any)
  {
    console.log("afterNextStep ...");
    switch(data.step)
    {
      case 1: // find customer
      {
        this.customerstep.completed = true;
        this.rmarequest.step = 2;
        this.stepper.next();
        break;
      }
      case 2: //add product
      {
        this.productstep.completed = true;
        this.rmarequest.step = 3;
        this.stepper.next();
        break;
      }
      case 3: //shipping
      {
        this.shippingstep.completed = true;
        this.rmarequest.step = 4;
        this.stepper.next();
        break;
      }
      case 4: //finish
      {
        console.log("finish");
        this.finishstep.completed = true;
        //this.rmarequest.step = 5;
        this.onFinish();
        break;
      }
    }
  }

  afterPrevStep(data : any)
  {
    console.log("afterPrevStep ...");
    this.rmarequest.step = this.rmarequest.step - 1;
    this.stepper.previous();
  }

  onFinish()
  {
    if (this.rmarequest != null
      && this.rmarequest.rma != null
      && this.rmarequest.rmaitems != null
      && this.rmarequest.rmaitems.length > 0) {

        var rmaData = this.rmarequest.convertToRmaRequestEx();
        this.service.insertData(rmaData).subscribe(
          res=>{
             ////this.toastr.success("Submit successfuly", "RMA Request");
             this.gnotify.showSnackBar('RMA Request', 'Submit successfuly', "success");
             if(rmaData.emailRequested)
             {
                this.service.sendRMARequestNotification(this.rmarequest.client).subscribe(
                  res=>{
                     ////this.toastr.success("Send email successfuly", "RMA Request");
                     this.gnotify.showSnackBar('RMA Request', 'Send email successfuly', "success");
                  },
                  err=>{
                    console.log(err);
                    ////this.toastr.error("Failed to send email", "RMA Request");
                    this.gnotify.showSnackBar('RMA Request', 'Failed to send email', "error");
                    return;
                  },
                  ()=>{
                    console.log("finalize");
                    this.router.navigateByUrl('/rma-list/standby');
                  }
                );
             }
             else
             {
               this.router.navigateByUrl('/rma-list/standby');
             }
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "RMA Request");
            this.gnotify.showSnackBar('RMA Request', 'Failed to Submit', "error");
            return;
          }
        );
    }
    else{
      ////this.toastr.error("Data is invalid", "RMA Request");
      this.gnotify.showSnackBar('RMA Request', 'Data is invalid', "error");
    }
  }
}
